<template>
  <div class="wrapper">
    <div class="__container">
      <img src="../assets/icons/logo_horizontal.svg" />
      <div class="banner">
        <h1>404</h1>
        <label>Page not found!</label>
        <div class="line">
          <span>Go to</span>
          <router-link to="/">
            <div class="home">
              <img src="../assets/icons/home_green.svg" />
              <span>Home</span>
            </div>
          </router-link>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "error404-page",
};
</script>

<style scoped lang="scss">
@import "../styles/main";
* {
  margin: 0;
  font-family: "Nunito", sans-serif;
  padding: 0;
  box-sizing: border-box;
}
.wrapper {
  width: 100%;
  min-height: 100%;
  overflow: hidden;
  background-image: url("../assets/icons/error_green.svg") !important;
  background-size: cover;
  background-repeat: no-repeat;
  position: relative;
  padding: 0;
  margin: 0;
  .__container {
    width: 80%;
    margin: 0 auto;
    img {
      height: 43px;
      width: 140px;
    }
    .banner {
      position: absolute;
      top: 50% !important;
      left: 50% !important;
      transform: translate(-50%, -60%);
      h1 {
        color: #fff;
        font-size: 176px;
        border-bottom: 1px solid #fff;
      }
      label {
        color: #fff;
        font-size: 40px;
        font-weight: lighter !important;
      }
      .line {
        display: flex;
        justify-content: center;
        a {
          text-decoration: none;
          &:hover {
            text-decoration: none;
          }
          .home {
            display: flex;
            background: #fff;
            padding: 2px 10px;
            border-radius: 5px;
            span {
              color: #04a5a5;
              font-size: 20px;
            }
            img {
              width: 18px;
              margin-top: 5px;
              margin-right: 10px;
              height: 18px;
            }
          }
        }
        span {
          color: #fff;
          font-size: 20px;
          margin-right: 20px;
        }
      }
    }
  }
}
</style>